module.exports = __webpack_public_path__ + "img/penazenka.ea8935b2.svg";